<app-modal
  [title]="dictionary.get('CreateTicket')"
  [(opened)]="modalOpened"
  (closeTrigger)="handleClose()"
  size="xl"
>
  @if (modalOpened()) {
    <form [formGroup]="form" (ngSubmit)="submit()" class="ticket-form">
      <label>
        <span>{{ dictionary.get('TicketTitle') }} *</span>
        <input
          class="input input-md"
          formControlName="title"
          [placeholder]="dictionary.get('TicketTitlePlaceholder')"
        />
      </label>
      <label>
        <span>{{ dictionary.get('Description') }}</span>
        <textarea
          class="input input-md"
          formControlName="description"
          rows="4"
          [placeholder]="dictionary.get('DescribeIssue')"
        ></textarea>
        <small class="content-requirement">
          {{ dictionary.get('CreateTicketContentRequired') }}
        </small>
      </label>
      <div class="form-row dropdown-upward">
        <div class="form-field">
          <span>{{ dictionary.get('Category') }} *</span>
          <app-select
            [options]="categoryOptions"
            [optionsIds]="categories"
            [defaultOption]="form.controls.category.value ? dictionary.get(form.controls.category.value) : undefined"
            [placeholder]="dictionary.get('SelectAnOption')"
            [isFullWidth]="true"
            (getSelectedOption)="selectCategory($event)"
          />
        </div>
        <div class="form-field">
          <span>{{ dictionary.get('Priority') }} *</span>
          <app-select
            [options]="priorityOptions"
            [optionsIds]="priorities"
            [defaultOption]="form.controls.priority.value ? dictionary.get(form.controls.priority.value) : undefined"
            [placeholder]="dictionary.get('SelectAnOption')"
            [isFullWidth]="true"
            (getSelectedOption)="selectPriority($event)"
          />
        </div>
      </div>

      <section class="attachment-panel">
        <div class="attachment-heading">
          <strong>{{ dictionary.get('AttachmentsOptional') }}</strong>
          @if (selectedUploadCount()) {
            <span class="selection-count">
              {{ selectedUploadCount() }} {{ dictionary.get('SelectedUploads') }}
            </span>
          }
        </div>
        <div class="attachment-actions">
          <label
            class="attachment-action"
            [class.has-file]="selectedUploadCount()"
            [title]="dictionary.get('ReplyAttachmentLimits')"
          >
            <ng-icon name="attachment" size="20" />
            <span>{{ dictionary.get('AttachFiles') }}</span>
            <input
              type="file"
              multiple
              [accept]="messageFileAccept"
              (change)="selectFiles($event)"
            />
          </label>
          <div class="record-action">
            <app-ticket-audio-recorder
              [selectedFile]="audioRecorded() ? audio() : null"
              (fileChange)="setRecordedAudio($event)"
            />
          </div>
        </div>

        @if (selectedUploadCount()) {
          <app-ticket-selected-uploads
            [attachments]="attachments()"
            [audio]="audio()"
            [audioRecorded]="audioRecorded()"
            [video]="video()"
            [previewUrl]="imagePreview"
            [labels]="{
              previewAttachment: dictionary.get('PreviewAttachment'),
              removeFile: dictionary.get('RemoveFile')
            }"
            (attachmentRemoved)="removeAttachment($event)"
            (audioRemoved)="clearAudio()"
            (videoRemoved)="clearVideo()"
            (attachmentOpened)="openSelectedAttachment($event)"
            (imageFailed)="selectedImageLoadFailed($event)"
          />
        }
      </section>

      <footer>
        <button
          buttonTheme="light"
          buttonType="regular"
          type="button"
          (click)="handleClose()"
        >{{ dictionary.get('Cancel') }}</button>
        <button
          buttonTheme="primary"
          buttonType="regular"
          type="submit"
          [disabled]="!canSubmit()"
        >{{ dictionary.get(submitting() ? 'Creating' : 'CreateTicket') }}</button>
      </footer>
    </form>
  }
</app-modal>

<app-ticket-attachment-preview
  [downloadLabel]="dictionary.get('Download')"
  [closeLabel]="dictionary.get('ClosePreview')"
  [loadingLabel]="dictionary.get('LoadingAttachmentPreview')"
  [sheetLabel]="dictionary.get('SpreadsheetSheet')"
  [emptySheetLabel]="dictionary.get('SpreadsheetEmptySheet')"
  [truncatedLabel]="dictionary.get('SpreadsheetPreviewTruncated')"
  (closed)="selectedImagePreviewClosed()"
  (failed)="attachmentPreviewFailed()"
/>
